export default class Accordion {
    constructor() {
        const accordionWrapper = document.querySelectorAll(
            '[data-behaviour="accordion"]',
        );
        if (accordionWrapper.length > 0) {
            accordionWrapper.forEach((accordion) => {
                const accord_toggles = accordion.querySelectorAll(
                    '[data-target="accordion-toggle"]',
                );

                accord_toggles.forEach((accord_toggle) => {
                    const parent = accord_toggle.closest(
                        '[data-target="accordion-item"]',
                    );

                    if (parent.classList.contains('active')) {
                        const content = parent.querySelector(
                            '[data-target="accordion-content"]',
                        );
                        if (content.scrollHeight) {
                            content.style.maxHeight =
                                content.scrollHeight + 5 + 'px';
                        }
                    }

                    accord_toggle.addEventListener('click', (ev) => {
                        ev.preventDefault();

                        parent.classList.toggle('active');
                        const content = parent.querySelector(
                            '[data-target="accordion-content"]',
                        );
                        if (content.style.maxHeight) {
                            content.style.maxHeight = null;
                        } else {
                            content.style.maxHeight =
                                content.scrollHeight + 'px';
                        }
                    });
                });
            });
        }
    }
}
